import type { Invite } from '../types'
import { InviteBadge } from './InviteBadge'

interface ConfirmationProps {
  invite: Invite
  onEditAgain: () => void
}

/** What replaces the form once the dog has taken the reply away. */
export function Confirmation({ invite, onEditAgain }: ConfirmationProps) {
  const coming = invite.people.filter((p) => p.response === 'yes')
  const notComing = invite.people.filter((p) => p.response === 'no')

  return (
    <div
      className="animate-reveal border-ink/10 bg-parchment/70 rounded-lg border p-6 shadow-sm sm:p-8"
      role="status"
      aria-live="polite"
    >
      <h2 className="font-display text-2xl">
        {coming.length > 0 ? 'Thank you - it is in the post' : 'Thank you for letting us know'}
      </h2>

      <dl className="mt-5 space-y-3 text-sm">
        {coming.length > 0 && (
          <div>
            <dt className="text-ink-soft text-xs tracking-widest uppercase">Joining us</dt>
            {coming.map((person) => (
              <dd key={person.person_id} className="mt-1">
                {person.name} <InviteBadge type={person.invite_type} />
              </dd>
            ))}
          </div>
        )}
        {notComing.length > 0 && (
          <div>
            <dt className="text-ink-soft text-xs tracking-widest uppercase">Cannot make it</dt>
            <dd className="mt-1">{notComing.map((p) => p.name).join(', ')}</dd>
          </div>
        )}
      </dl>

      <p className="text-ink-soft mt-5 text-sm">
        {coming.length > 0
          ? 'We cannot wait to see you. Everything you need to know is below.'
          : 'We will miss you, but we completely understand.'}
      </p>

      <button
        type="button"
        onClick={onEditAgain}
        className="border-ink/20 hover:border-claret hover:text-claret mt-6 rounded-md border px-5 py-2.5 text-sm tracking-widest uppercase transition-colors"
      >
        Change our answer
      </button>
    </div>
  )
}
